import { win, doc, vendors } from './environment';

export var visible;
var hidden = 'hidden';

if ( doc ) {
	var prefix;

	if ( hidden in doc ) {
		prefix = '';
	} else {
		var i = vendors.length;
		while ( i-- ) {
			var vendor = vendors[i];
			hidden = vendor + 'Hidden';

			if ( hidden in doc ) {
				prefix = vendor;
				break;
			}
		}
	}

	if ( prefix !== undefined ) {
		doc.addEventListener( prefix + 'visibilitychange', onChange );
		onChange();
	} else {
		// gah, we're in an old browser
		if ( 'onfocusout' in doc ) {
			doc.addEventListener( 'focusout', onHide );
			doc.addEventListener( 'focusin', onShow );
		}

		else {
			win.addEventListener( 'pagehide', onHide );
			win.addEventListener( 'blur', onHide );

			win.addEventListener( 'pageshow', onShow );
			win.addEventListener( 'focus', onShow );
		}

		visible = true; // until proven otherwise. Not ideal but hey
	}
}

function onChange () {
	visible = !doc[ hidden ];
}

function onHide () {
	visible = false;
}

function onShow () {
	visible = true;
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/config/visibility.js.map
